import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer({ categories = [] }) {
    const legalLinks = [
        { to: "/about", label: "About Us" },
        { to: "/contact", label: "Contact Us" },
        { to: "/privacy-policy", label: "Privacy Policy" },
        { to: "/terms", label: "Terms & Conditions" },
    ];
    return (
        <footer
            data-testid="site-footer"
            className="mt-24 border-t-2 border-black bg-white"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-4 gap-10">
                {/* Brand */}
                <div className="md:col-span-1">
                    <div className="font-display text-3xl font-black">
                        Free AI Writers
                    </div>
                    <div className="text-xs uppercase tracking-widest font-bold text-neutral-600 mt-0.5">
                        Free AI Tools
                    </div>
                    <p className="mt-3 text-sm text-neutral-700">
                        A directory of 101+ free AI writing tools. No signups.
                        No paywalls.
                    </p>
                </div>

                {/* Categories */}
                <div className="md:col-span-2">
                    <div className="font-bold mb-3 text-black uppercase tracking-widest text-xs">
                        Categories
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {categories.slice(0, 10).map((c) => (
                            <Link
                                key={c.slug}
                                to={`/category/${c.slug}`}
                                data-testid={`footer-cat-${c.slug}`}
                                className="text-sm font-bold hover:underline underline-offset-4 decoration-2"
                            >
                                {c.name}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Legal & Info */}
                <div className="md:col-span-1">
                    <div className="font-bold mb-3 text-black uppercase tracking-widest text-xs">
                        Company
                    </div>
                    <ul className="space-y-2 text-sm">
                        {legalLinks.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-${l.to.replace("/", "")}`}
                                    className="font-bold hover:underline underline-offset-4 decoration-2"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="border-t-2 border-black px-5 md:px-10 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs">
                <p className="text-neutral-700 max-w-3xl">
                    Disclaimer: Free AI Writers outputs are AI-generated and may
                    be inaccurate. Do not rely on them for legal, medical, or
                    financial decisions.
                </p>
                <div className="flex flex-wrap gap-4 items-center font-bold uppercase tracking-widest">
                    <span>© {new Date().getFullYear()} Free AI Writers</span>
                    <span className="inline-flex items-center gap-2">
                        built with{" "}
                        <Heart className="w-3.5 h-3.5" strokeWidth={3} /> & pixels
                    </span>
                </div>
            </div>
        </footer>
    );
}
